"use strict";
/*
Copyright 2020 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplunkDocumentLoadInstrumentation = void 0;
const instrumentation_document_load_1 = require("@opentelemetry/instrumentation-document-load");
const servertiming_1 = require("./servertiming");
const core_1 = require("@opentelemetry/core");
const excludedInitiatorTypes = ['beacon', 'fetch', 'xmlhttprequest'];
function addExtraDocLoadTags(span) {
    if (document.referrer && document.referrer !== '') {
        span.setAttribute('document.referrer', document.referrer);
    }
    if (window.screen) {
        span.setAttribute('screen.xy', window.screen.width + 'x' + window.screen.height);
    }
}
class SplunkDocumentLoadInstrumentation extends instrumentation_document_load_1.DocumentLoadInstrumentation {
    constructor(config = {}) {
        super(config);
        const exposedSuper = this;
        const _superEndSpan = exposedSuper._endSpan.bind(this);
        exposedSuper._endSpan = (span, performanceName, entries) => {
            var _a;
            // TODO: upstream exposed name on api.Span, then fix
            const exposedSpan = span;
            if (span && exposedSpan.name !== 'documentLoad') { // only apply links to document/resource fetch
                // To maintain compatibility, getEntries copies out select items from
                // different versions of the performance API into its own structure for the
                // initial document load (but leaves the entries undisturbed for resource loads).
                if (exposedSpan.name === 'documentFetch' &&
                    !entries.serverTiming &&
                    performance.getEntriesByType) {
                    const navEntries = performance.getEntriesByType('navigation');
                    if ((_a = navEntries[0]) === null || _a === void 0 ? void 0 : _a.serverTiming) {
                        entries.serverTiming = navEntries[0].serverTiming;
                    }
                }
                (0, servertiming_1.captureTraceParentFromPerformanceEntries)(entries, span);
            }
            if (span && exposedSpan.name === 'documentLoad') {
                addExtraDocLoadTags(span);
            }
            return _superEndSpan(span, performanceName, entries);
        };
        const _superInitResourceSpan = exposedSuper._initResourceSpan.bind(this);
        exposedSuper._initResourceSpan = (resource, parentSpan) => {
            if (excludedInitiatorTypes.indexOf(resource.initiatorType) !== -1 || (0, core_1.isUrlIgnored)(resource.name, config.ignoreUrls)) {
                return;
            }
            _superInitResourceSpan(resource, parentSpan);
        };
    }
}
exports.SplunkDocumentLoadInstrumentation = SplunkDocumentLoadInstrumentation;
//# sourceMappingURL=SplunkDocumentLoadInstrumentation.js.map